(function () {
  var CLOSE_SVG =
    '<svg class="ciw-shopify-pc__close-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M1.5 14.5 8 8m6.5-6.5L8 8m6.5 6.5L8 8M1.5 1.5 8 8"></path>' +
    '</svg>';

  var MOBILE_LATE_OVERRIDES =
    '@media (max-width:749px){' +
    '#shopify-pc__banner.shopify-pc__banner__dialog{bottom:0!important;left:0!important;right:0!important;top:auto!important;width:auto!important;max-width:none!important;min-height:0!important;height:auto!important;padding:16px!important;margin:0!important;border:none!important;border-radius:0!important;box-shadow:none!important;background:linear-gradient(180deg,rgba(2,6,33,0) 0%,rgba(2,6,33,.1) 100%)!important;overflow:visible!important;text-align:left!important}' +
    '#shopify-pc__banner .shopify-pc__banner__wrapper{display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;gap:0!important;width:100%!important;max-width:342px!important;margin:0 auto!important;background:#fff!important;border:1px solid rgba(0,0,0,.12)!important;border-radius:12px!important;box-shadow:0 1px 5px rgba(0,0,0,.05),0 12px 16px rgba(0,0,0,.09),0 6px 12px 1px rgba(0,0,0,.04)!important;overflow:hidden!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body{display:block!important;flex:unset!important;min-width:0!important;width:100%!important;margin:0!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body h2{margin:0!important;padding:13px 16px!important;border-bottom:1px solid #dbe1e5!important;font-size:16px!important;font-weight:700!important;line-height:18px!important;color:#020621!important;text-align:left!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body p{margin:0!important;padding:14px 16px 16px!important;font-size:13px!important;font-weight:400!important;line-height:18px!important;color:#3a4850!important;text-align:left!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body a,#shopify-pc__banner .shopify-pc__banner__btn-manage-prefs{font-size:13px!important;font-weight:400!important;line-height:18px!important;color:#1774de!important;text-decoration:underline!important;text-decoration-thickness:1px!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns,#shopify-pc__banner .shopify-pc__banner__btns-granular{display:block!important;flex:unset!important;width:100%!important;min-width:0!important;max-width:none!important;height:auto!important;margin:0!important;padding:0 16px 20px!important;align-self:stretch!important;text-align:center!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns-granular>*{order:unset!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btn-accept{display:inline-flex!important;flex:none!important;flex-grow:0!important;flex-shrink:0!important;flex-basis:auto!important;width:100%!important;min-width:0!important;max-width:311px!important;height:40px!important;min-height:40px!important;max-height:40px!important;margin:0 auto!important;padding:6px 17px!important;border:2px solid #020621!important;background-color:#020621!important;color:#fff!important;border-radius:20px!important;font-size:16px!important;font-weight:700!important;line-height:17px!important;align-self:center!important}' +
    '}';

  var LATE_OVERRIDES =
    '@media (min-width:750px){' +
    '#shopify-pc__banner .shopify-pc__banner__wrapper{display:flex!important;flex-direction:row!important;align-items:center!important;gap:22px!important;width:100%!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body{margin:0!important;width:auto!important;flex:1 1 auto!important;min-width:0!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns{display:block!important;flex:0 0 150px!important;width:150px!important;min-width:150px!important;max-width:150px!important;height:auto!important;margin:28px 0 0!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btn-accept{display:inline-flex!important;flex:none!important;flex-grow:0!important;flex-shrink:0!important;flex-basis:auto!important;width:150px!important;min-width:150px!important;max-width:150px!important;height:40px!important;min-height:40px!important;max-height:40px!important;margin:0!important;border:none!important;background-color:#1774de!important;color:#fff!important}' +
    '}' +
    '#shopify-pc__banner .shopify-pc__banner__btn-decline,#shopify-pc__banner .shopify-pc__banner__btns .shopify-pc__banner__btn-manage-prefs{display:none!important}' +
    '#shopify-pc__banner.ciw-gusa-ready .shopify-pc__banner__body .shopify-pc__banner__btn-manage-prefs{display:inline!important}' +
    MOBILE_LATE_OVERRIDES;

  var consentApiReady = false;
  var consentApiQueue = [];

  function injectLateOverrides() {
    var style = document.getElementById('ciw-shopify-pc-late-overrides');
    if (!style) {
      style = document.createElement('style');
      style.id = 'ciw-shopify-pc-late-overrides';
      document.head.appendChild(style);
    }
    // Only write when the content actually changed. Writing textContent every
    // time replaces the style tag's text node, which the page-wide
    // MutationObserver sees as a childList change -> it calls this again ->
    // infinite loop that pegs the CPU and freezes the page.
    if (style.textContent !== LATE_OVERRIDES) {
      style.textContent = LATE_OVERRIDES;
    }
  }

  function dismissBanner(banner) {
    if (!banner || banner.classList.contains('ciw-shopify-pc-dismissed')) return;
    banner.classList.add('ciw-shopify-pc-dismissed');
    banner.classList.remove('ciw-shopify-pc-show');
    banner.hidden = true;
    banner.setAttribute('aria-hidden', 'true');
    banner.style.setProperty('display', 'none', 'important');
    banner.style.setProperty('visibility', 'hidden', 'important');
    banner.style.setProperty('pointer-events', 'none', 'important');
  }

  function revealBanner(banner) {
    if (!banner || banner.classList.contains('ciw-shopify-pc-dismissed')) return;
    banner.classList.add('ciw-shopify-pc-show');
    banner.hidden = false;
    banner.removeAttribute('aria-hidden');
    banner.style.removeProperty('display');
    banner.style.removeProperty('visibility');
    banner.style.removeProperty('pointer-events');
  }

  /** True only when Shopify already stored yes/no — empty strings mean no choice yet. */
  function hasExplicitConsent(privacy) {
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    try {
      var consent = privacy.currentVisitorConsent();
      if (!consent) return false;
      var keys = ['analytics', 'marketing', 'preferences', 'sale_of_data'];
      for (var i = 0; i < keys.length; i++) {
        var value = consent[keys[i]];
        if (value === 'yes' || value === 'no') return true;
      }
    } catch (error) {
      /* ignore */
    }
    return false;
  }

  function withConsentApi(callback) {
    if (consentApiReady) {
      callback();
      return;
    }

    consentApiQueue.push(callback);

    if (consentApiQueue.length > 1) return;

    if (!(window.Shopify && window.Shopify.loadFeatures)) {
      consentApiQueue.forEach(function (fn) {
        fn();
      });
      consentApiQueue = [];
      return;
    }

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      consentApiReady = !error;
      var queue = consentApiQueue.slice();
      consentApiQueue = [];
      queue.forEach(function (fn) {
        fn();
      });
    });
  }

  function saveConsent(callback) {
    withConsentApi(function () {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        if (callback) callback();
        return;
      }

      try {
        privacy.setTrackingConsent(
          {
            analytics: true,
            marketing: true,
            preferences: true,
            sale_of_data: false,
          },
          function () {
            if (callback) callback();
          }
        );
      } catch (error) {
        try {
          privacy.setTrackingConsent(true, function () {
            if (callback) callback();
          });
        } catch (fallbackError) {
          if (callback) callback();
        }
      }
    });
  }

  function handleAccept(banner) {
    dismissBanner(banner);
    saveConsent(function () {
      dismissBanner(banner);
    });
    window.setTimeout(function () {
      dismissBanner(banner);
    }, 250);
  }

  function bindAcceptDismiss(banner, acceptBtn) {
    if (!banner || !acceptBtn || acceptBtn.dataset.ciwAcceptBound === '1') return;
    acceptBtn.dataset.ciwAcceptBound = '1';

    acceptBtn.addEventListener('click', function () {
      handleAccept(banner);
    });
  }

  function styleBanner(banner) {
    if (!banner || banner.dataset.ciwGusaReady === '1') return;
    banner.dataset.ciwGusaReady = '1';
    banner.classList.add('ciw-gusa-ready');

    var acceptBtn = banner.querySelector('#shopify-pc__banner__btn-accept');
    var declineBtn = banner.querySelector('#shopify-pc__banner__btn-decline');
    var manageBtn = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var bodyCopy = banner.querySelector('.shopify-pc__banner__body p');

    if (acceptBtn) acceptBtn.textContent = 'Continue';
    if (declineBtn) declineBtn.setAttribute('hidden', 'hidden');

    if (manageBtn && bodyCopy && !bodyCopy.querySelector('[data-ciw-manage-moved]')) {
      manageBtn.setAttribute('data-ciw-manage-moved', '1');
      manageBtn.textContent = 'Cookie Manager';
      bodyCopy.appendChild(document.createTextNode(' To manage your selections, please see our '));
      bodyCopy.appendChild(manageBtn);
      bodyCopy.appendChild(document.createTextNode('.'));
    }

    if (!banner.querySelector('.ciw-shopify-pc__close-wrap')) {
      var closeWrap = document.createElement('div');
      closeWrap.className = 'ciw-shopify-pc__close-wrap';
      closeWrap.innerHTML =
        '<button type="button" class="ciw-shopify-pc__close" aria-label="close">' + CLOSE_SVG + '</button>';
      banner.appendChild(closeWrap);

      var closeBtn = closeWrap.querySelector('button');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          handleAccept(banner);
        });
      }
    }

    injectLateOverrides();
  }

  function syncBanner(banner) {
    if (!banner) return;
    if (banner.classList.contains('ciw-shopify-pc-dismissed')) return;

    bindAcceptDismiss(banner, banner.querySelector('#shopify-pc__banner__btn-accept'));

    // Wait for Consent API before show/hide.
    // Do NOT auto-dismiss on *ProcessingAllowed() — true by default in US.
    // Do NOT gate on shouldShowBanner() — Shopify returns false for US IPs even
    // when the store cookie banner is enabled, which hid the banner entirely.
    // Hide only after explicit stored consent or user Continue / X.
    withConsentApi(function () {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      try {
        if (privacy && hasExplicitConsent(privacy)) {
          dismissBanner(banner);
          return;
        }
      } catch (error) {
        /* ignore and still show */
      }

      styleBanner(banner);
      revealBanner(banner);
    });
  }

  function watchForBanner() {
    syncBanner(document.getElementById('shopify-pc__banner'));

    document.addEventListener('visitorConsentCollected', function () {
      dismissBanner(document.getElementById('shopify-pc__banner'));
    });

    var observer = new MutationObserver(function () {
      var node = document.getElementById('shopify-pc__banner');
      if (node) {
        syncBanner(node);
      }

      if (document.getElementById('shopify-pc__banner__styles')) {
        injectLateOverrides();
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForBanner);
  } else {
    watchForBanner();
  }
})();
